import { type DependencyList, useEffect } from "react";

export const useOnMainScrollAreaScroll = (
  handleScroll: () => void,
  deps: DependencyList,
) => {
  useEffect(() => {
    window.onMainScrollAreaScroll = handleScroll;

    return () => {
      window.onMainScrollAreaScroll = undefined;
    };
  }, [...deps]);
};
